import React from 'react'
import PropTypes from 'prop-types'

import Box from 'suitTheme/Box'
import Image from 'suitTheme/Image'
import ListItem from 'suitTheme/ListItem'
import Text from 'suitTheme/Text'

const Campaign = (props) => {
  const {
    boxProps,
    children,
    disableHover,
    imageUrl,
    onClick,
    subtitle,
    title,
  } = props

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        borderBottom: '1px dashed',
        borderColor: 'lineColor',
        paddingY: 'large',
        ...boxProps,
      }}
      disableHover={disableHover}
      onClick={onClick}
    >
      <Box marginRight="medium" width="auto">
        <Image url={imageUrl} circle width={30} height={30} />
      </Box>

      <Box flexDirection="column">
        <Text fontSize="small">{title}</Text>
        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
          {subtitle}
        </Text>
      </Box>

      {children}
    </ListItem>
  )
}

Campaign.propTypes = {
  boxProps: PropTypes.object,
  children: PropTypes.node,
  disableHover: PropTypes.bool,
  imageUrl: PropTypes.string,
  onClick: PropTypes.func,
  subtitle: PropTypes.string,
  title: PropTypes.string,
}

export default Campaign
